import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DevicesService, LangService, LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {ActivityService} from 'src/app/shared/services/activity.service';
import {ApiService} from 'src/app/shared/services/api.service';
import {ActivatedRoute} from '@angular/router';
import {SyncService} from 'src/app/shared/services/sync.service';

@Component({
  selector: 'app-more-activity',
  templateUrl: './more-activity.component.html',
  styleUrls: ['./more-activity.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MoreActivityComponent implements OnInit, OnDestroy {
  activities: any;
  filterActivities: any;
  type: 'account' | 'shared';
  isReload = false;
  isWeb: boolean;

  constructor(public api: ApiService,
    public activity: ActivityService,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private formBuilder: FormBuilder,
    private sync: SyncService,
    private lang: LangService,
    public nav: NavigateService,
    private devices: DevicesService) {
    this.isWeb = !this.devices.isDevices('cordova');
    this.route.queryParams.subscribe(params => {
      this.type = params && (params.type);
    });
  }

  form: FormGroup;

  ngOnInit(): void {
    if(!this.sync.isOnline) {
      this.loader.loading(true, {type: 'info', message: this.lang.transform('no_connection'), btnLabel: 'confirm'}).then(() => {
        this.nav.to('more');
      });
    }
    this.loader.loading(true);
    this.activity.getActivities(this.type).then(()=>{
      this.loader.loading(false);
    });
    this.setForm();
  }

  ngOnDestroy(): void {
    this.activity.resetActivities();
  }

  setForm() {
    this.form = this.formBuilder.group({search: ['']});
  }

  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    if(target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if(this.isReload) return;
      this.isReload = true;
      this.loader.loadingElement('bottom', true, 'xs');
      setTimeout(() =>{
        this.activity.loadMoreActivities().then(() => {
          this.loader.loadingElement('bottom', false);
          this.isReload = false;
        });
      }, 1000);
    }
  }
}
